module.exports = function (specialsGroupService) {
    return {
        link(scope) {
            scope.specialsGroupsService = specialsGroupService;
        },
        template: require('./specials-group-display-template.html')
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/specials/specials-group-display-directive.js
 **/